'use strict';

var GridToolbarController = function GridToolbarController($scope) {
  $scope.gridPanelScope = $scope.$parent;
  $scope.$on('pooled-seasonality-special-events:showSpecialEventsFromParent', function (event, isSaveSpecialEventShow) {
    $scope.$broadcast('pooled-seasonality-special-events:showSpecialEvents', isSaveSpecialEventShow);
  });
};
GridToolbarController.$inject = ['$scope'];
module.exports = GridToolbarController;